(ns ui.view.survey.grid
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.utils :as fu]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.ck-editor.view :as ck-editor]
   [ui.util :as uu]
   [ui.view.survey.components :as components]
   [ui.view.survey.event :as event]
   [ui.view.survey.modals.confirm-overwrite-answers :as overwrite-existing-answers-modal]
   [ui.view.survey.modals.confirm-remove-column :as confirm-remove-row-modal]
   [ui.view.survey.modals.confirm-submit :as confirm-submit-modal]
   [ui.view.survey.modals.loading-excel :as loading-excel-modal]
   [ui.view.survey.modals.mandatory-missing :as mandatory-missing-modal]
   [ui.view.survey.modals.num-fmt-select :as num-fmt-modal]
   [ui.view.survey.modals.resolve-errors :as resolve-errors-modal]
   [ui.view.survey.modals.select-sheet :as select-sheet-modal]
   [ui.view.survey.modals.tesi-esg-errors :as tesi-errors-modal]
   [ui.view.survey.modals.missing-sheets :as missing-sheets-modal]
   [ui.view.survey.sub :as sub]
   [ui.window :as window]))



(defn header
  [survey-id]
  (let [targeted-label @(rf/subscribe [::sub/survey-label-display survey-id])
        lang @(rf/subscribe [::sub/selected-lang survey-id])
        hero-img-url @(rf/subscribe [::sub/hero-img-url survey-id])
        target-name @(rf/subscribe [::sub/target-name-if-not-in-label survey-id])
        access-to-other-surveys? @(rf/subscribe [::sub/access-to-other-surveys?])]
    [:<>
     [:div
      {:class "py-3 flex items-center shrink-0 grow-0 gap-2 justify-items-stretch"}
      (when hero-img-url
        [:img
         {:class "max-h-[40px] mx-3"
          :src   hero-img-url}])
      (when access-to-other-surveys?
        [:div
         {:class "flex items-center flex-auto justify-end gap-5"}
         [button/sm-secondary-hollow
          {:on-click (fn [_]
                       (rf/dispatch [::event/re-select-survey]))}
          (loc/tr :switch-to-another-survey nil lang)]])]

     [:div
      {:class "px-4 flex items-center shrink-0 grow-0 gap-2 justify-items-stretch"}
      [:div
       {:class (fu/cs "text-[26px] font-bold flex-auto text-base-light-text")}
       targeted-label]]

     [:div
      {:class "pl-4 flex items-center shrink-0 grow-0 gap-2 justify-items-stretch"}
      (if target-name
        [:div
         {:class "pl-4 flex-auto font-bold"}
         target-name]
        [components/reporting-period-text survey-id lang])
      [:div
       {:class "flex items-center flex-auto justify-end gap-5"}
       (when target-name
         [components/reporting-period-text survey-id lang])
       [components/lang-selector survey-id lang]]]]))


(defn wysiwyg-block
  [block]
  [:div
   {:class "flex-auto content-stretch"}
   [:div
    {:class "mb-4 flex flex-col"}
    [:div
     {:class "flex flex-col w-full"}
     (when-not (cu/empty-value? (:label block))
       [:h2
        {:class "text-helper-light-text text-lg font-semibold bg-helper-light px-4 py-2"}
        (:label block)])
     [:div
      {:class "flex-auto"}
      [:div
       {:class "p-3 text-sm text-complement-regular-text bg-complement-regular rounded"}
       [ck-editor/viewer (:content block)]]]]]])

(defn grid
  [survey-id]
  (let [inner-height (:height @(rf/subscribe [::window/window-size]))
        grid-height (str (int (- inner-height 120)) "px")]
    [:<>
     [:div {:class "block shrink-0 *:w-full"
            :style {:height     grid-height
                    :min-height grid-height}}
      [components/ag-grid
       {:survey-id            survey-id
        :question-min-width   200
        :col-series-min-width 120}]]]))

(defn body
  [survey-id]
  (let [configuration @(rf/subscribe [::sub/survey-config survey-id])
        lang @(rf/subscribe [::sub/selected-lang])
        validate-counter @(rf/subscribe [::sub/validate-counter survey-id])
        numeric-questions? @(rf/subscribe [::sub/numeric-questions? survey-id])]
    [:div
     {:class (uu/cm "pt-6 flex flex-col flex-1 container gap-2 max-w-[1024px]")}
     [:div
      {:class "flex shrink-0 grow-0 flex-col content-stretch gap-2"}
      (->> configuration
           :blocks
           (cu/filter-by :block-type :survey-block/wysiwyg)
           (map-indexed (fn [idx block]
                          ^{:key (str "survey-text-block-" idx "-" lang)}
                          [wysiwyg-block block]))
           (doall))
      [:div
       {:class "flex flex-row justify-content-end gap-2"}
       [components/tesi-fund-excel-block survey-id]
       (when numeric-questions?
         [:div
          {:class-name "hidden md:flex"}
          [components/thousand-separator]])
       (when numeric-questions?
         [:div
          {:class-name "hidden md:flex"}
          [components/decimal-separator]])
       [components/add-remove-columns-buttons false survey-id lang]
       [button/secondary-open
        {:on-click (fn [_]
                     (rf/dispatch [::event/change-form-style survey-id :survey-form.style/grid-full]))}
        (loc/tr :expand-table nil lang)
        [:i.fal.fa-expand-alt]]]
      ^{:key (str "survey-validate-" validate-counter)}
      [grid survey-id]]]))

(defn view
  [survey-id]
  [:div
   {:class "max-w-[1024px] text-light-text flex flex-auto flex-col mx-auto gap-2 px-2 pt-2 w-full"}
   [header survey-id]
   [body survey-id]
   ;; modals & off-screen
   [select-sheet-modal/view]
   [resolve-errors-modal/view]
   [tesi-errors-modal/view]
   [missing-sheets-modal/view]
   [overwrite-existing-answers-modal/view]
   [confirm-remove-row-modal/view]
   [confirm-submit-modal/view]
   [num-fmt-modal/view]
   [loading-excel-modal/view survey-id]
   [mandatory-missing-modal/view survey-id]])
